import { h, Host } from "@stencil/core";
/**
 * UxTableCaptionNeo - Experimental table caption component
 * @slot - The content of the caption
 */
export class TableRowNeo {
    host;
    render() {
        return (h(Host, { key: '7895409d52464007bfbe092955f84fa89538b332', role: "caption" }, h("slot", { key: 'f77eef295148102280b8ee2ee4ae3e21288694e4' })));
    }
    static get is() { return "ux-table-caption-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-caption-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-caption-neo.css"]
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=table-caption-neo.js.map
